import './form.scss';
import './form-validation';
import './form-ajax';
import { initFieldRelations } from './form-field-relation';
import { customizeFileInputs } from './form-file-input';
import { customizeDateInputs } from './form-date-input';
import { customizePasswordInputs } from './form-password-input';
import { initCoupons } from './form-coupon-input';
import { fixCustomSelect } from './form-field-select';
import { initSubmitHandling } from './form-submit';
import { initSteps } from './form-steps';
import { initSessionRenewal } from './form-session';
import { initAppContacts } from './form-app-contacts';
import { initCustomFields } from './form-custom-fields';
import { initPhoneConfirmations } from './form-phone-confirmation';

function initForm(form) {
	const selects = form.querySelectorAll('.mdc-select');

	const options = (form.dataset.formOptions ? JSON.parse(form.dataset.formOptions) : null) || {};

	// Print mode
	if (window.LN && window.LN.printMode) {
		let isAdditionalCountry;

		selects.forEach(element => {
			const select = element.querySelector('select');
			const isCountry = !!select.querySelector('option[value^="country"]');

			if (!select || (isCountry && isAdditionalCountry)) {
				return;
			}

			select.setAttribute('multiple', 'multiple');
			select.setAttribute('size', select.children.length);

			isAdditionalCountry = isCountry;
		});

		return;
	}

	// Auto-submit
	if (options.submitOnChange) {
		form.addEventListener('change', () => {
			if (options.ajax) {
				form.dispatchEvent(
					new CustomEvent('submit', {
						bubbles: true,
						cancelable: true
					})
				);
			} else {
				form.submit();
			}
		});
	}

	// Customize some inputs
	customizeFileInputs(form);
	customizeDateInputs(form);
	customizePasswordInputs(form);
	initPhoneConfirmations(form);

	// Coupon admin
	initCoupons(form);

	// Disable form on submit to prevent multi-submit
	if (!options.customAjax) {
		initSubmitHandling(form);
	}

	// Init MDC stuff
	initCustomFields(form);

	// Properly size non-native dropdowns and handle icon content
	selects.forEach(element => {
		fixCustomSelect(element.MDCSelect);
	});

	// Make sure the session is kept alive while filling a form
	initSessionRenewal(form);

	// Wait for `fixCustomSelect` to have run, e.g.
	setTimeout(() => {
		// Field relations
		initFieldRelations(form, {
			onShow: initVisibleFields,
			initForm
		});

		// Handle app contacts
		initAppContacts(form, {
			initForm
		});

		// Handle steps variant
		if (options.steps) {
			initSteps(form, {
				onShow: initVisibleFields
			});
		}

		// Focus specific field
		if (options.field) {
			const field = document.querySelector(`[name="${options.field}"]`);

			setTimeout(() => {
				field.focus();
			});
		}

		// Expose state
		form.classList.add('is-initialized');
	});

	// Autofill fix
	setTimeout(() => {
		// IE will choke on the `:-webkit-autofill` selector
		try {
			form.querySelectorAll('.mdc-text-field__input:-webkit-autofill').forEach(el => {
				const textField = el.parentNode;
				const label = textField.querySelector('.mdc-floating-label');

				if (label) {
					label.classList.add('mdc-floating-label--float-above');
				}

				if (textField.MDCTextField) {
					textField.MDCTextField.foundation_.notchOutline(true);
				}
			});
		} catch (err) {}
	}, 300);
}

// Properly size notch of initially hidden fields
function initVisibleFields(root) {
	root.querySelectorAll('.mdc-text-field, .mdc-select--outlined').forEach(element => {
		const notchedOutline = element.querySelector('.mdc-notched-outline--notched');
		const Component = element.MDCTextField || element.MDCSelect;

		if (notchedOutline && Component) {
			Component.foundation_.notchOutline(true);
		}

		element.dispatchEvent(new CustomEvent('LN:updateFieldVisibility'));
	});
}

// Run on all forms
const forms = document.querySelectorAll('form, [data-init="form"]');

forms.forEach(form => {
	initForm(form);
});

export { initVisibleFields, initForm };
